/* ════════════════════════════════════════════════════════════════════
   SIP TEQUILA · BRAND RATE CARD — runtime
   Vanilla, no dependencies. Initializes once on DOMContentLoaded.
   Reads CONFIG from the LOCK section's data-* attributes.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  function init() {
    var ROOT = document;
    var lockSection = ROOT.querySelector('.brc-section--lock');
    var CONFIG = readConfig(lockSection);

    var state = {
      selected: {},
      tequila: {},
      partner: false,
      examplesOpen: defaultExamplesOpen(ROOT),
    };

    var NAME_BY_ID = buildNameMap(ROOT);

    /* ─── pricing visibility ─── */
    if (!CONFIG.showPricing) {
      ROOT.querySelectorAll('.brc-rc-row').forEach(function (row) {
        var priced = row.querySelector('.brc-rc-row__price');
        var hidden = row.querySelector('.brc-rc-row__hidden');
        if (priced) priced.hidden = true;
        if (hidden) hidden.hidden = false;
      });
      ROOT.querySelectorAll('.brc-pg-card').forEach(function (card) {
        var priced = card.querySelector('.brc-pg-card__price');
        var hidden = card.querySelector('.brc-pg-card__hidden');
        if (priced) priced.hidden = true;
        if (hidden) hidden.hidden = false;
      });
      var pourPriceWrap = ROOT.querySelector('.brc-pour-cta__price-wrap');
      if (pourPriceWrap) pourPriceWrap.hidden = true;
      var pricingNote = ROOT.querySelector('.brc-rc__pricing-note');
      if (pricingNote) pricingNote.hidden = false;
    }

    /* ─── group default open state: only g-email open ─── */
    var groups = ROOT.querySelectorAll('.brc-rc-group');
    groups.forEach(function (g) {
      var open = (g.dataset.groupId === 'g-email');
      g.classList.toggle('is-open', open);
      setGroupOpenUI(g, open);
    });

    /* ─── examples body default open ─── */
    applyExamplesUI(ROOT, CONFIG, state.examplesOpen);

    /* ─── lock gate ─── */
    var gate = ROOT.querySelector('.brc-lock');
    if (gate) {
      var unlocked = false;
      try { unlocked = localStorage.getItem('sip_ratecard_unlocked') === '1'; } catch (e) {}
      if (unlocked) gate.hidden = true;
      var codeInput = gate.querySelector('.brc-lock__input');
      var codeError = gate.querySelector('.brc-lock__error');
      var enterBtn = gate.querySelector('.brc-lock__btn');
      function tryUnlock() {
        var val = ((codeInput && codeInput.value) || '').trim().toUpperCase();
        if (val === (CONFIG.accessCode || '').toUpperCase()) {
          try { localStorage.setItem('sip_ratecard_unlocked', '1'); } catch (e) {}
          gate.hidden = true;
          if (codeError) codeError.hidden = true;
        } else {
          if (codeError) codeError.hidden = false;
        }
      }
      if (enterBtn) enterBtn.addEventListener('click', tryUnlock);
      if (codeInput) {
        codeInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') tryUnlock(); });
        codeInput.addEventListener('input', function () { if (codeError) codeError.hidden = true; });
      }
    }

    /* ─── delegated click handler ─── */
    ROOT.addEventListener('click', function (e) {
      var t = e.target.closest('[data-brc-action]');
      if (!t) return;
      var action = t.dataset.brcAction;
      if (action === 'scroll') {
        e.preventDefault();
        var target = t.dataset.brcTarget;
        if (target) scrollToId(target);
      } else if (action === 'toggle-item') {
        toggleItem(t.dataset.brcId);
      } else if (action === 'toggle-group') {
        toggleGroup(t.closest('.brc-rc-group'));
      } else if (action === 'toggle-examples') {
        state.examplesOpen = !state.examplesOpen;
        applyExamplesUI(ROOT, CONFIG, state.examplesOpen);
      } else if (action === 'car-prev') {
        var car1 = ROOT.querySelector('.brc-pour-car');
        if (car1) car1.scrollBy({ left: -360, behavior: 'smooth' });
      } else if (action === 'car-next') {
        var car2 = ROOT.querySelector('.brc-pour-car');
        if (car2) car2.scrollBy({ left: 360, behavior: 'smooth' });
      } else if (action === 'toggle-partner') {
        state.partner = !state.partner;
        var box = t.querySelector('.brc-box');
        if (box) box.classList.toggle('is-on', state.partner);
      } else if (action === 'toggle-tequila') {
        var tt = t.dataset.brcTt;
        if (state.tequila[tt]) delete state.tequila[tt]; else state.tequila[tt] = true;
        var ttBox = t.querySelector('.brc-box');
        if (ttBox) ttBox.classList.toggle('is-on', !!state.tequila[tt]);
      } else if (action === 'submit') {
        submitInquiry();
      }
    });

    function toggleItem(id) {
      if (!id) return;
      var on = !state.selected[id];
      if (on) state.selected[id] = true; else delete state.selected[id];
      ROOT.querySelectorAll('[data-brc-id="' + cssEsc(id) + '"]').forEach(function (el) {
        el.classList.toggle('is-selected', on);
        var box = el.querySelector('.brc-box');
        if (box) box.classList.toggle('is-on', on);
        if (el.classList.contains('brc-pour-cta__btn')) {
          var label = el.querySelector('.brc-pour-cta__btn-label');
          if (label) label.textContent = on ? 'Added to inquiry' : 'Add to inquiry';
        }
      });
      renderInterest();
      renderFloating();
    }

    function toggleGroup(group) {
      if (!group) return;
      var open = !group.classList.contains('is-open');
      group.classList.toggle('is-open', open);
      setGroupOpenUI(group, open);
    }

    function setGroupOpenUI(group, open) {
      var rows = group.querySelector('.brc-rc-rows');
      if (rows) rows.hidden = !open;
      var icon = group.querySelector('.brc-rc-head__toggle-icon');
      var lbl = group.querySelector('.brc-rc-head__toggle-label');
      var count = group.querySelectorAll('.brc-rc-row').length;
      if (icon) icon.textContent = open ? '–' : '+';
      if (lbl) lbl.textContent = open ? 'Hide' : ('View ' + count);
    }

    function renderInterest() {
      var list = ROOT.querySelector('.brc-interest-list-wrap');
      if (!list) return;
      var ids = Object.keys(state.selected);
      if (ids.length === 0) {
        list.innerHTML = '<div class="brc-interest-empty">Nothing added yet, scroll up to the rate card and tap anything you\'re curious about, or just tell us below.</div>';
        return;
      }
      list.innerHTML = '<div class="brc-interest-list">' + ids.map(function (id) {
        var name = NAME_BY_ID[id] || id;
        return '<span class="brc-interest-pill">' + escHtml(name) + '</span>';
      }).join('') + '</div>';
    }

    function renderFloating() {
      var floating = ROOT.querySelector('.brc-floating');
      if (!floating) return;
      var label = floating.querySelector('.brc-floating__label');
      var n = Object.keys(state.selected).length;
      floating.hidden = false;
      if (label) {
        if (n === 0) {
          label.textContent = floating.dataset.defaultLabel || 'Start an inquiry';
        } else {
          label.textContent = n + (n === 1 ? ' item, review inquiry' : ' items, review inquiry');
        }
      }
    }

    function submitInquiry() {
      var form = ROOT.querySelector('.brc-form');
      if (!form) return;
      var val = function (selName) {
        var node = form.querySelector('[data-brc-field="' + selName + '"]');
        return node ? (node.value || '').trim() : '';
      };
      var brand = val('brand');
      var email = val('email');
      var goal = val('goal');
      var errEl = form.querySelector('.brc-form__error');
      if (!brand || !email || email.indexOf('@') === -1 || !goal) {
        if (errEl) errEl.hidden = false;
        return;
      }
      if (errEl) errEl.hidden = true;

      var interests = Object.keys(state.selected).map(function (id) { return NAME_BY_ID[id]; }).filter(Boolean);
      var payload = {
        firstName: val('firstName'),
        lastName: val('lastName'),
        contact: (val('firstName') + ' ' + val('lastName')).trim(),
        brand: brand,
        nom: val('nom'),
        email: email,
        phone: val('phone'),
        website: val('website'),
        importer: val('importer'),
        currentDistributors: val('distributors'),
        tequilaTypes: Object.keys(state.tequila),
        budget: val('budget'),
        message: val('message'),
        bottlePhotos: val('bottlePhotos'),
        sellSheet: val('sellSheet'),
        additionalFiles: val('additionalFiles'),
        offerType: val('offerType'),
        offerValue: val('offerValue'),
        duration: val('offerLength'),
        goal: val('goal'),
        featuredProducts: val('featured'),
        poweredByPartner: state.partner,
        interests: interests,
        submittedAt: new Date().toISOString(),
      };

      var submitBtn = form.querySelector('.brc-form__submit');
      if (submitBtn) submitBtn.textContent = 'SENDING…';

      var finish = function () {
        var body = form.querySelector('.brc-form__body');
        var success = form.querySelector('.brc-success');
        if (body) body.hidden = true;
        if (success) success.hidden = false;
        scrollToFormSection();
      };

      if (CONFIG.webhookUrl) {
        try {
          fetch(CONFIG.webhookUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          }).catch(function (err) { console.warn('[Sip Rate Card] Webhook POST failed:', err); })
            .finally(finish);
        } catch (e) {
          console.warn('[Sip Rate Card] Webhook fetch threw:', e);
          finish();
        }
      } else {
        console.log('[Sip Rate Card] No webhook URL set — inquiry payload:', payload);
        finish();
      }
    }

    function scrollToFormSection() {
      var section = ROOT.querySelector('.brc-section--form');
      if (!section) return;
      var top = section.getBoundingClientRect().top + window.scrollY - 64;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    renderInterest();
    renderFloating();
  }

  /* ─── helpers ─── */
  function readConfig(lockSection) {
    var d = (lockSection && lockSection.dataset) || {};
    return {
      accessCode: d.accessCode || 'SIPFAMILIA',
      webhookUrl: d.webhookUrl || '',
      showPricing: d.showPricing !== 'false',
      hideExamplesLabel: d.hideExamplesLabel || 'Hide examples',
      viewExamplesLabel: d.viewExamplesLabel || 'View examples',
    };
  }

  function defaultExamplesOpen(ROOT) {
    var section = ROOT.querySelector('.brc-section--examples');
    if (!section) return true;
    return section.dataset.defaultOpen !== 'false';
  }

  function buildNameMap(ROOT) {
    var map = {};
    ROOT.querySelectorAll('[data-brc-id][data-brc-name]').forEach(function (el) {
      map[el.dataset.brcId] = el.dataset.brcName;
    });
    return map;
  }

  function applyExamplesUI(ROOT, CONFIG, open) {
    var body = ROOT.querySelector('.brc-ex__body');
    if (body) body.hidden = !open;
    var lbl = ROOT.querySelector('.brc-ex__label');
    var chev = ROOT.querySelector('.brc-ex__chev');
    if (lbl) lbl.textContent = open ? (CONFIG.hideExamplesLabel || 'Hide examples') : (CONFIG.viewExamplesLabel || 'View examples');
    if (chev) chev.textContent = open ? '–' : '+';
  }

  function scrollToId(id) {
    if (!id) return;
    id = id.replace(/^#/, '');
    var el = document.getElementById(id);
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.scrollY - 64;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  function escHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }
  function cssEsc(s) {
    if (window.CSS && window.CSS.escape) return window.CSS.escape(s);
    return String(s).replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }
})();
